import { getSurfaceStore } from '../store/publishedCalendarSurfaceStore';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

/**
 * Check if the agenda pane can be shown
 */
export default function canShowAgendaPane(): boolean {
    const { selectedDate, dateRangeType } = getSurfaceStore();
    return dateRangeType === DateRangeType.Month && !!selectedDate;
}
